<template>
    <div>
    <l-circle-marker :lat-lng="latlng"
    :radius="8"
    :stroke="false"
    :fillColor="color"
    :fillOpacity="0"
    v-on:click="click"/>
    <l-marker :lat-lng="latlng">
              <l-icon
              :iconSize= "isize"
              :iconAnchor= "ianchor"
               >
                <img class="aircraft" :style="a_style"  :src="a_img">
              </l-icon>
    </l-marker>
    <l-polyline
        :lat-lngs="latlngs"
        :opacity="opacity-0.2"
        :weight="wpath"
        :color="color"
        :visible="vpath"
        :interactive="false"
    />
    </div>
</template>

<script>

/*############################################
Monkey patching leaflet for control center top
#############################################*/
import L from 'leaflet';
(function (L /*, window, document, undefined*/) {
    "use strict";

    //Extend Map._initControlPos to also create a topcenter-container
    L.Map.prototype._initControlPos = function ( _initControlPos ) {
        return function () {
            //Original function/method
            _initControlPos.apply(this, arguments);
            //Adding new control-containers
            //topcenter is the same as the rest of control-containers
            this._controlCorners['topcenter'] = L.DomUtil.create('div', 'leaflet-top leaflet-center', this._controlContainer);

            //bottomcenter need an extra container to be placed at the bottom
            this._controlCorners['bottomcenter'] =
                L.DomUtil.create(
                    'div',
                    'leaflet-bottom leaflet-center',
                    L.DomUtil.create('div', 'leaflet-control-bottomcenter',    this._controlContainer)
                );
        };
    } (L.Map.prototype._initControlPos);
}(L, this, document));
/*############################################
End patch
#############################################*/

import { LMarker, LIcon, LPolyline, LCircleMarker} from 'vue2-leaflet';

export default {
    name: 'LAircraft',
    components: {
        LMarker,
        LIcon,
        LPolyline,
        LCircleMarker
    },

    methods: {
        click () {
        this.$emit('aircraft:select', this.addr)
        }
    },

    computed: {
        a_img () {
                if (this.type===1){
                    return (this.alive ? require('@/assets/glider_blue.png') : require('@/assets/glider_red.png'))
                    }
                else {
                    return (this.alive ? require('@/assets/plane_blue.png') : require('@/assets/plane_red.png'))
                }
        },
        opacity () {return (this.alive ? 1 : 0.6)},
        a_style () {
                return {
                    filter: `opacity(${this.opacity})`,
                    transform: `rotate(${this.rotate}deg)`
                }
        },
        isize () {return (this.select ? [100, 100] : [50, 50])},
        ianchor () {return (this.select ? [50, 50] : [25, 25])},
        latlng () {return this.latLng},
        latlngs () {
            // only last 30 fix when small path enabled (approx 5 min)
            if (this.spath) {return this.latLngs.slice(-30)}
            else {return this.latLngs}
            },
        color () {return (this.alive ? '#7a7acf' : 'red')},
        path_color () {return (this.alive ? 'dimgray' : 'red')},
    },

    props: {
        latLng: Object,                    // Aircraft position
        latLngs: Array,                    // Path Polyline
        rotate: Number,                    // Aircraft rotation 0-360
        alive: Boolean,     
        select: Boolean,    
        vpath: Boolean,                    // Path visible flag
        spath: Boolean,                    // Small Path flag
        wpath: {type:Number, default:2},   // Path weight
        addr: String,                      // Aircraft Device Address
        type: Number                       // 1 aircraft, ...
       
    }
    }
</script>

<style>
.aircraft {
    margin: 0;
    transform-origin: center;
    width: 100%;
    height: 100%;
    }
.leaflet-marker-icon.leaflet-zoom-animated.leaflet-interactive {
    pointer-events: none;
}
/*############################################
Monkey patching leaflet for control center top
#############################################*/
.leaflet-top.leaflet-center {
    left: 50%;
    transform: translate(-50%, 0%);
}
</style>